import { useMemo } from 'react';
import { useLazyQuery } from '@apollo/client';
import { CERTIFICATE_OVERRIDE } from '../../queries';

export function useCertificateOverridesQuery( certificateTemplateId, options ) {
    const [ fetchCertificateOverrides, { data: rawData, loading, error, refetch, called } ] = 
        useLazyQuery( CERTIFICATE_OVERRIDE, {
            ...options,
            variables: { 
                ...options?.variables, 
                certificateTemplateId: certificateTemplateId 
            },
        } );

    return useMemo ( () => {
        return {
            fetch: fetchCertificateOverrides,
            error,
            loading,
            data: rawData,
            refetch,
            called
        };
    }, [ error, loading, rawData, refetch ] );
}
